/* global axios */

import ApiClient from './ApiClient';

class EcommerceAPI extends ApiClient {
  constructor() {
    super('ecommerce', { accountScoped: true });
  }

  getContactOrders(contactId) {
    return axios.get(`${this.url}/orders`, {
      params: { contact_id: contactId },
    });
  }

  getContactTrackingEvents(contactId, page = 1) {
    return axios.get(`${this.url}/tracking_events`, {
      params: { contact_id: contactId, page },
    });
  }
}

export default new EcommerceAPI();
